export default __webpack_public_path__ + "static/media/Landing2.1f038f81.png";